import { render, staticRenderFns } from "./CPostcodeAutocomplete.vue?vue&type=template&id=67f78932&"
import script from "./CPostcodeAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./CPostcodeAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports